/* Balkan — produse complementare.
 *
 * Cere API-ul de recomandari cu `intent=complementary`. Daca nu exista
 * complementare configurate in Search & Discovery, raspunsul e gol si cerem
 * `intent=related`, dar SCHIMBAM titlul: „Merge bine cu" e o afirmatie despre
 * potrivire, iar produsele doar asemanatoare nu o susțin.
 *
 * Randarea vine de la server (Section Rendering API), deci preturile sunt
 * formatate de Liquid, la fel ca in restul magazinului.
 */
(function () {
  function inject(root, html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-bk-cross-list]');
    if (!fresh || !fresh.children.length) return false;
    root.querySelector('[data-bk-cross-list]').replaceWith(fresh);
    root.hidden = false;
    return true;
  }

  document.querySelectorAll('[data-bk-cross]').forEach(function (root) {
    var base = root.getAttribute('data-url');
    if (!base) return;
    var h = root.querySelector('[data-bk-cross-h]');

    fetch(base + '&intent=complementary', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        if (inject(root, html)) return null;           /* avem complementare reale */
        return fetch(base + '&intent=related', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
          .then(function (html2) {
            if (inject(root, html2) && h && h.dataset.hRelated) h.textContent = h.dataset.hRelated;
            return null;
          });
      })
      .catch(function () { /* fara recomandari, secțiunea rimine ascunsa */ });
  });
})();
